/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

( function( app ) {
  const COMPONENT = {
    init: function() {
      const copyButton = document.querySelector( '.social-share__link.share-link' );

      copyButton?.addEventListener( 'click', () => {
        navigator.clipboard.writeText( copyButton.dataset.url )
            .then( () => {
              const copied = copyButton.parentElement.querySelector( '.copied-text' );
              copied?.classList.add( 'is-copied' );
              setTimeout( () => copied?.classList.remove( 'is-copied' ), 2000 );
            } )
            .catch( () => {} );
      } );

      // Blog index: filter category sections by hero filter buttons + URL param
      const blogIndex = document.querySelector( '.blog-index' );
      const filterBtns = blogIndex?.querySelectorAll( '.blog-hero__filter-btn' );
      const categorySections = blogIndex?.querySelectorAll( '.blog__category-section' );

      function getCategoryParam() {
        const params = new URLSearchParams( window.location.search );
        return params.get( 'category' ) || '';
      }

      function setCategoryParam( slug ) {
        const url = new URL( window.location.href );
        if ( !slug || slug === 'all' ) {
          url.searchParams.delete( 'category' );
        } else {
          url.searchParams.set( 'category', slug );
        }
        window.history.replaceState( {}, '', url.toString() );
      }

      function setActiveFilter( categoryId, categorySlug ) {
        filterBtns.forEach( ( b ) => {
          b.classList.remove( 'is-active' );
          b.setAttribute( 'aria-pressed', 'false' );
        } );
        const activeBtn = Array.from( filterBtns ).find( ( b ) => b.getAttribute( 'data-category-id' ) === String( categoryId ) );
        if ( activeBtn ) {
          activeBtn.classList.add( 'is-active' );
          activeBtn.setAttribute( 'aria-pressed', 'true' );
        }

        categorySections.forEach( ( section ) => {
          const sectionCatId = section.getAttribute( 'data-category-id' );
          const sectionSlug = section.getAttribute( 'data-category-slug' );
          const show = categoryId === 'all' || String( sectionCatId ) === String( categoryId ) || sectionSlug === categorySlug;
          section.style.display = show ? '' : 'none';
          section.hidden = !show;
        } );
      }

      if ( filterBtns?.length && categorySections?.length ) {
        // On load: apply filter from URL param (PHP already set initial state; this keeps URL and UI in sync if JS runs after)
        const initialCategory = getCategoryParam();
        if ( initialCategory && initialCategory !== 'all' ) {
          const section = Array.from( categorySections ).find( ( s ) => s.getAttribute( 'data-category-slug' ) === initialCategory );
          if ( section ) {
            setActiveFilter( section.getAttribute( 'data-category-id' ), initialCategory );
          }
        }

        filterBtns.forEach( ( btn ) => {
          btn.addEventListener( 'click', () => {
            const categoryId = btn.getAttribute( 'data-category-id' );
            const categorySlug = btn.getAttribute( 'data-category-slug' ) || '';
            setActiveFilter( categoryId, categorySlug );
            setCategoryParam( categoryId === 'all' ? '' : categorySlug );
          } );
        } );
      }
    },

    finalize: function() {
    },
  };

  app.registerComponent( 'blog', COMPONENT );
} )( app );
